var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:this.styleClass + ' facebook-button',attrs:{"type":"button"},on:{"click":_vm.facebook}},[_vm._v(" Continue with Facebook ")])}
var staticRenderFns = []

export { render, staticRenderFns }